import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "app/store/hook";
import { UserInfoModel } from "app/model/ua/user-info";
import { clearUserInfo } from "app/reducers/userSlice";
import { Link, useNavigate } from "react-router-dom";
import AccountAlarm from "./AccountAlarm";
import { logoutRedirect } from "app/config/oidc";

export default function Account() {
  const [isUserLogin, setIsUserLogin] = useState<any>(false);
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo?.userId) {
      setIsUserLogin(true);
    } else {
      setIsUserLogin(false);
    }
  }, [userInfo?.userId]);

  const handleClickUser = (e: any) => {
    e.preventDefault();
    navigate('/mypage');
  }

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(clearUserInfo());
    logoutRedirect();
  };

  return (
    <ul>
      <li className="login">
        {
          isUserLogin
            ? (<Link to="" className="out" onClick={handleClickUser} title="내 정보 화면으로 이동"><span>안녕하세요. <strong>{userInfo?.userNm}</strong>님</span></Link>)
            : (<Link to="/" title="로그인 화면으로 이동"><span>로그인 해주세요</span></Link>)
        }
      </li>
      {
          isUserLogin && (<AccountAlarm/>)
      }
      {
        isUserLogin && (
          <>
            <li className="logout">
              <Link to="" onClick={(e) => handleLogout(e)} title="로그아웃"><span className="hid">로그아웃</span></Link>
            </li>
          </>
        )
      }
    </ul>
  )
}